import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { DetailResponse } from "@/api/usen-manage/response";
import * as ShopAPI from "@/api/usen-manage";
import { isSuccess } from "@/api/response";
import { DetailRequest } from "@/api/usen-manage/request";

const MODULE_NAME = "usen-manage/detail";

/**
 * 店舗詳細情報取得API（/detail-shop）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Detail extends VuexModule {
  // state
  detailResponse: DetailResponse = {} as DetailResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.detailResponse);
  }

  get getMessage() {
    return this.detailResponse.message;
  }

  get getDetail() {
    return this.detailResponse.results;
  }

  get isMainShop() {
    if (this.detailResponse.results) {
      return this.detailResponse.results.modelType === 2;
    } else {
      return false;
    }
  }

  // MutationActions
  @MutationAction
  async detail(detailRequest: DetailRequest) {
    const detailResponse = await ShopAPI.detail(detailRequest);
    return {
      detailResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      detailResponse: {} as DetailResponse
    };
  }
}

export default getModule(Detail);
